import React from 'react'
import PropTypes from 'prop-types'

import { Row, DataFields, HeaderColumn, TotalHeaderText, Total, RowContainer } from '../styles/BillStyles'

function BillLineItemsTableHeader({ editable = false }) {
  return (
    <RowContainer>
      <Row editable={editable}>
        <DataFields editable={editable}>
          <HeaderColumn basis="15%" minwidth={editable ? '100px' : '0'}>
            Type
          </HeaderColumn>
          <HeaderColumn basis="33%" minwidth={editable ? '125px' : '0'}>
            Description
          </HeaderColumn>
          <HeaderColumn basis="11%" minwidth={editable ? '75px' : '0'}>
            Quantity
          </HeaderColumn>
          <HeaderColumn basis="18%" minwidth={editable ? '120px' : '0'}>
            Unit
          </HeaderColumn>
          <HeaderColumn basis="12%" minwidth={editable ? '75px' : '0'}>
            Price / Unit
          </HeaderColumn>
          <HeaderColumn basis="10%" minwidth={editable ? '75px' : '0'}>
            Tax (%)
          </HeaderColumn>
        </DataFields>
        <Total>
          <TotalHeaderText editable={editable}>Total</TotalHeaderText>
        </Total>
      </Row>
    </RowContainer>
  )
}

BillLineItemsTableHeader.propTypes = {
  editable: PropTypes.bool
}

export default BillLineItemsTableHeader
